import { EnumOrInput, GmwSelect, OrganisationSelect } from "./features/form-widgets";
import { FileWidget } from "./features/form-widgets/components/widget-file";
import { GmnSelectDropdown } from "./features/form-widgets/components/widget-gmn-select-dropdown";
import { GmnSelectTable } from "./features/form-widgets/components/widget-gmn-select-table";
import { SelectWidget } from "./features/form-widgets/components/widget-select";

export const WIDGETS = {
  EnumOrInput,
  OrganisationSelect,
  GmwSelect,
  GmnSelectTable,
  FileWidget,
  GmnSelectDropdown,
  Hidden: () => null,
  SelectWidget,
};
